import { State } from '@progress/kendo-data-query';
import React, { useMemo } from 'react';
import percentRecQtyColumns from 'src/assets/static/view_invoice/percentRecQtyColumns';
import Grid from 'src/components/GridWrapper';
import { ThreeWayMatchingPermissions } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';

const initialPercentRecQtyState: State = {
  take: 1,
  skip: 0,
};

const defaultProps = {
  showColumnMenu: false,
  sortable: false,
  DataItemKey: 'poQty',
};

interface IPercentRecQtyWizard {
  dataSource: any;
}

const PercentRecQtyWizard: React.FC<IPercentRecQtyWizard> = ({ dataSource }) => {
  const isThreeWayMatching: boolean = usePermission({ permissions: ThreeWayMatchingPermissions });
  const gridColumns = useMemo(() => {
    let sampleColumns = percentRecQtyColumns;
    if (!isThreeWayMatching) {
      sampleColumns = sampleColumns.filter(
        (column) => !['receivingQty', 'receiptVariance'].includes(column.field || '')
      );
    }
    return sampleColumns;
  }, [isThreeWayMatching]);

  return (
    <>
      <div className="mt-1 mb-1 px-1">
        <Grid
          className="percentRecGrid viewInvoiceModalGrid no_Veritcal_ScrollBar"
          dataSource={[dataSource]}
          dataState={initialPercentRecQtyState}
          total={1}
          onDataStateChange={() => {}}
          columns={gridColumns}
          {...defaultProps}
        />
      </div>
    </>
  );
};

export default PercentRecQtyWizard;
